<template>
  <div class="home-wrap">
    <HeroSection @play-film="scrollToFilm" />
    <QuotesSection />
    <InfrastructureSection />
    <ConsumerModelSection />
    <SolutionsSection />
    <FilmSection ref="filmSection" />
    <ProjectSection />
    <News />
    <DiscussSection />
    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import News from "./components/News.vue";
import DiscussSection from "./components/DiscussSection.vue";
import FilmSection from "./components/FilmSection.vue";
import HeroSection from "./components/HeroSection.vue";
import ConsumerModelSection from "./components/ConsumerModelSection.vue";
import InfrastructureSection from "./components/InfrastructureSection.vue";
import QuotesSection from "./components/QuotesSection.vue";
import SolutionsSection from "./components/SolutionsSection.vue";
import ProjectSection from "./components/ProjectSection.vue";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index.vue";

export default {
  components: {
    News,
    HeroSection,
    FilmSection,
    DiscussSection,
    ConsumerModelSection,
    InfrastructureSection,
    QuotesSection,
    ProjectSection,
    SolutionsSection,
    VFooter,
    QuestionPopup
  },
  name: "home",
  data() {
    return {};
  },
  methods: {
    // HeroSection 按钮点击：打开视频弹窗播放
    scrollToFilm() {
      this.$refs.filmSection.playVideo();
    },
  },
};
</script>

<style lang="less" scoped>
.home-wrap {
  position: relative;
  background: #ffffff;
}
</style>
